import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  MenuItem,
  Pagination,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const exportStockToPDF = (stockData = []) => {
  const doc = new jsPDF("landscape");
  const columns = [
    "Summary",
    "SKU",
    "Data de Intrare",
    "Nume și Prenume",
    "Preț Intrare",
    "Tip Achiziție",
  ];
  const rows = stockData.map((item) => [
    item.summary || "N/A",
    item.sku || "N/A",
    item.data_de_intrare
      ? new Date(item.data_de_intrare).toLocaleDateString()
      : "N/A",
    item.nume_si_prenume || "N/A",
    item.pret_intrare_ron || "N/A",
    item.tip_achizitie || "N/A",
  ]);
  autoTable(doc, {
    head: [columns],
    body: rows,
  });
  doc.save("Stocuri.pdf");
};

function StocuriTab() {
  const [stockData, setStockData] = React.useState([]);
  const [category, setCategory] = React.useState("");
  const [filteredStockData, setFilteredStockData] = React.useState([]);
  const [page, setPage] = React.useState(1);
  const ITEMS_PER_PAGE = 30;

  React.useEffect(() => {
    const fetchStockData = async () => {
      try {
        const response = await fetch(
          "https://server-9p4hx.kinsta.app/get-all-jira-stocuri"
        );
        const data = await response.json();
        setStockData(data);
        setFilteredStockData(data);
      } catch (error) {
        console.error("Eroare la preluarea datelor stoc:", error);
      }
    };
    fetchStockData();
  }, []);

  React.useEffect(() => {
    const filtered = stockData.filter((item) => {
      if (category === "null") {
        return item.categorie_prod === null || item.categorie_prod === "";
      } else if (category) {
        return item.categorie_prod === category;
      } else {
        return true;
      }
    });
    setFilteredStockData(filtered);
    setPage(1); // Reset la prima pagină la schimbare categorie
  }, [category, stockData]);

  const pageCount = Math.ceil(filteredStockData.length / ITEMS_PER_PAGE);
  const paginatedStockData = filteredStockData.slice(
    (page - 1) * ITEMS_PER_PAGE,
    page * ITEMS_PER_PAGE
  );

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: 2,
        }}
      >
        <TextField
          select
          label="Selectează Categoria"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          SelectProps={{
            native: true,
          }}
          variant="outlined"
        >
          <option value="">Toate</option>
          <option value="null">Fără</option>
          {stockData
            .map((item) => item.categorie_prod)
            .filter(
              (value, index, self) => value && self.indexOf(value) === index
            )
            .map((cat, index) => (
              <option key={index} value={cat}>
                {cat}
              </option>
            ))}
        </TextField>
        <Button
          variant="contained"
          color="primary"
          startIcon={<CloudDownloadIcon />}
          onClick={() => exportStockToPDF(filteredStockData)}
          sx={{ m: 2 }}
        >
          Exportă în PDF
        </Button>
      </Box>

      <Grid container spacing={2} sx={{ padding: 2 }}>
        {paginatedStockData.map((item, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <Card sx={{ display: "flex", height: "100%" }}>
              <CardMedia
                component="img"
                alt={item.summary}
                sx={{ width: "200px", height: "auto" }}
                image={item.df_image_link || "placeholder-image-url"}
                title={item.summary}
              />
              <Box sx={{ display: "flex", flexDirection: "column", flex: "1" }}>
                <CardContent sx={{ flex: "1 0 auto" }}>
                  <Typography
                    variant="h6"
                    gutterBottom
                    sx={{
                      wordBreak: "break-word",
                      whiteSpace: "normal",
                      overflowWrap: "break-word",
                      maxWidth: "100%",
                    }}
                  >
                    {item.summary}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    SKU: {item.sku}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Data de Intrare:{" "}
                    {new Date(item.data_de_intrare).toLocaleDateString()}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Nume și Prenume: {item.nume_si_prenume}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Preț Intrare: {item.pret_intrare_ron} RON
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Tip Achiziție: {item.tip_achizitie}
                  </Typography>
                </CardContent>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "center", padding: 2 }}>
        <Pagination
          count={pageCount}
          page={page}
          onChange={handleChangePage}
          color="primary"
        />
      </Box>
    </>
  );
}

export default StocuriTab;
